var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.hasRunStatus)?_c(_setup.SChip,{attrs:{"color":_setup.statusDefinition.color,"text":_vm.$t(_setup.statusDefinition.text),"icon":_setup.statusDefinition.icon,"running":_setup.isRunning,"plain":_vm.plain,"emphasize":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }